globalThis.backoffice = globalThis.backoffice || {};

backoffice.ModalFilters = (function(superClass)
{
    utils.extend(ModalFilters, superClass);

    function ModalFilters($html) {
      return ModalFilters.__super__.constructor.apply(this, arguments);
    }

    $.extend(ModalFilters.prototype, {
      init: function() {
        backoffice.initSelect2(this.$html.find('.select'));
        backoffice.initSelect2Search(this.$html.find('.select-search'));
        this.$html.find('.styled').uniform({radioClass: 'choice'});
        this.$html.find('.checkbox-switchery').each(function() { new Switchery($(this).find('input[type=checkbox]')[0]); });
        this.$html.find('.filter-container label.toggle-filter').each(function() { $(this).sbBoToggleFilter() });
        backoffice.initDatePickers(this.$html);

        ModalFilters.__super__.init.apply(this, arguments);
      }
    });

    return ModalFilters;
})(backoffice.ModalMain);
